import ApiClient from './ApiClient';

class AgentConsoleAPI extends ApiClient {
  constructor() {
    super('agent_console', { accountScoped: true });
  }
}

export default new AgentConsoleAPI();
